import { documentAPI } from '../../../services/documentAPI';

export async function contentRequestId(tenderId, file) {
  const digest = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
  const hash = [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${tenderId}:${hash}`;
}

export async function uploadTenderDocument(file, { tenderId, typeCode, accessClassification, versionOf, documentArea }) {
  const body = new FormData();
  body.append('document', file);
  body.append('tenderId', tenderId);
  if (typeCode) body.append('typeCode', typeCode);
  if (documentArea) body.append('documentArea', documentArea);
  body.append('accessClassification', accessClassification || 'standard');
  body.append('clientRequestId', await contentRequestId(tenderId, file));
  if (versionOf) body.append('versionOf', versionOf);
  const response = await documentAPI.uploadDocument(body);
  return {
    skipped: Boolean(response.data?.data?.skipped),
    message: response.data?.message || '',
    document: response.data?.data?.document
  };
}
